// extracted by mini-css-extract-plugin
export default {"CrashDetailDisplay":"CrashDetailDisplay__CrashDetailDisplay__hcsEe"};